import { Link } from 'react-router';

import { dayOf, describe } from '../../dates';
import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// The patient's other submissions of the same questionnaire, newest first,
// each with whether the clinician reviewed it and leading to its own review.
// Shown only when there are any.
export function EarlierAttempts({ patientId, earlier }) {
  const { text, language } = useLanguage();

  if (earlier.length === 0) {
    return null;
  }

  const rows = earlier.map(function({ id, submittedAt, reviewedAt }) {
    let state = text.notReviewed;

    if (reviewedAt != null) {
      state = text.reviewedOn.replace('{date}', describe({ day: dayOf(reviewedAt), language, short: true }));
    }

    return (
      <Link key={ id } className={ styles.row } to={ `/patients/${ patientId }/tests/${ id }` }>
        <span className={ styles.when }>{ describe({ day: dayOf(submittedAt), language, short: true }) }</span>
        <span className={ styles.state }>{ state }</span>
      </Link>
    );
  });

  return (
    <section className={ styles.earlier } aria-labelledby='earlier-attempts'>
      <h2 id='earlier-attempts' className={ styles.heading }>{ text.earlierAttempts }</h2>

      { rows }

      <span className={ styles.hint }>{ text.keptAsSubmitted }</span>
    </section>
  );
}
